import { useStore } from "@state/store"
import { useLayoutEffect } from "react"
import styled from "styled-components/macro"

const Location = ({ children }) => {
  const syncState = useStore((s) => s.syncState)

  useLayoutEffect(() => {
    syncState({ categoriesVisible: true })
  }, [])
  return <LocationWr>{children}</LocationWr>
}

const LocationWr = styled.div`
  z-index: 1000;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: 100%;
  width: 100%;
  background-color: var(--primary);
  color: var(--secondary);

  .map-categories {
    display: flex;
    align-items: center;
    justify-content: space-around;
    gap: 1rem;

    margin-bottom: 1em;

    &.visible {
      opacity: 1;
      z-index: 1;
      transition: all 1s;
    }

    &.hidden {
      opacity: 0;
      z-index: -1;
      transition: all 0.3s;
    }

    .buttons {
      min-width: 6em;
      border: none;
      flex: 1;
      background-color: transparent;
      color: #252525d6;
      border-radius: 10rem;

      &.active {
        color: white;
        background-color: var(--accent);
      }
    }
  }

  .locationCategory {
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    z-index: 10;
  }

  .map-poi-box {
    cursor: pointer;
    transition: 0.3s;
    overflow: hidden;
    // very subtle box shadow
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);

    &.active {
      /* transform: scale(0.95); */
      /* transition: 0.3s; */
      // box shadow as border with primary color
      box-shadow: inset 0 0 0 2px var(--primary);
    }
  }

  .areas {
    z-index: 10;
    display: flex;
    flex-direction: row;
    top: 15%;
    left: 0;
    position: absolute;
    width: 15%;
    height: 100px;
  }

  .map-wrapper {
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    #map {
      flex: 1;
      height: 100%;
      width: auto;

      .marker {
        opacity: 0;
        transition:
          opacity 400ms ease-in,
          transform 400ms ease-in;
      }

      .marker {
        opacity: 1;
      }
    }
  }

  .list-wr {
    position: absolute;
    top: 0;
    left: 0;
    width: 25%;
    height: 100%;
    padding: 0 2em;
  }
`

export default Location
